
import Vue from 'vue';
import type { ISalesRole } from '@/types/community';
import MultiselectForm from '~/components/common/MultiselectForm/MultiselectForm.vue';
import type { CreateSalesRoleResponse } from '~/types/api';

interface IComponentData {
  salesRoles: Array<ISalesRole>;
}

export default Vue.extend({
  name: 'WarRoomEditProfileFormSalesRoles',
  components: {
    MultiselectForm,
  },
  inheritAttrs: false,
  data(): IComponentData {
    return {
      salesRoles: [],
    };
  },
  async mounted() {
    const { sales_roles: salesRoles } = await this.$api.$get('/api/war_room/sales_roles.json', {
      params: {
        custom: false,
      },
    });

    this.salesRoles = salesRoles;
  },
  methods: {
    async createSalesRole(name: string): Promise<ISalesRole | void> {
      try {
        const salesRole = await this.$api.$post<CreateSalesRoleResponse>('/api/war_room/sales_roles.json', { name });
        await this.$api.$post(`/api/war_room/sales_roles/${salesRole.id}/attach.json`);

        return salesRole;
      } catch (e) {
        this.$notice.error(e);
        this.$sentryUtils.error(e);
      }
    },
  },
});
